<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <p class="mb-5 text-justify">
        Ingresar número de código y el rango de fechas del pago que desea
        consultar.
      </p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        showFilterConvenios
        :Convenios="convenios"
        @click-buscar="buscar"
        @click-event="clickEvent"
        showFilterDates
        :dataLength="dataLength"
        :perPage="perPage"
        filtro
        pagination
        showExportToPdf
      >
        <table-column
          slot="label"
          :label="'Número de Archivo'"
          v-bind:value="'nombre_de_archivo'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Codigo'"
          v-bind:value="'convenio'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor'"
          v-bind:value="'valor'"
          :filter="'numberFormat'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cantidad de Registros'"
          v-bind:value="'cantidad_de_registros'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha Pago'"
          v-bind:value="'fecha_de_pago'"
        ></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import FileSaver from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      perPage: 10,
      fecha_inicio: this.$moment().startOf("month").format("YYYY-MM-DD"),
      fecha_fin: this.$moment().format("YYYY-MM-DD"),
      convenio: null,
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      loading: "loading",
    }),
    convenios() {
      let data = this.$store.getters["pages/convenios"].map((convenio) => {
        return { value: convenio.id, text: convenio.nombre_convenio };
      });
      data.unshift({ value: null, text: "Codigo", disabled: true });
      return data;
    },
    dataLength() {
      return this.$store.getters["pages/total"];
    },
    data() {
      return this.$store.getters["pages/dataInformes"];
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    async clickEvent(data, slug) {
      console.log(data)
      this.fecha_inicio = data.fecha_inicio;
      this.fecha_fin = data.fecha_fin;
      this.convenio = data.convenio;
      switch (slug) {
          case "paginacion":
          this.perPage = data.nRows;
          this.index();
          break;
        case "export-to-pdf":
          if (this.data.length > 0) {
            this.$toasted.show(
              "Por favor espere mientras exportamos los datos",
              {
                theme: "toasted-primary",
                position: "top-center",
                duration: 10000,
              }
            );
            this.$store.commit("SET_LOADING", true);
            try {
              let response = await this.$store.state.api.post(
                "portal/informes/memorando/exportar",
                {
                  fecha_inicio: this.$moment(this.fecha_inicio).format(
                    "YYYY-MM-DD"
                  ),
                  fecha_fin: this.$moment(this.fecha_fin).format("YYYY-MM-DD"),
                  convenio: this.convenio,
                  paginar: 0,
                },
                { responseType: "arraybuffer" }
              );

              var today = new Date();
              var dd = String(today.getDate()).padStart(2, "0");
              var mm = String(today.getMonth() + 1).padStart(2, "0");
              var yyyy = today.getFullYear();
              var hour = today.getHours();
              var minute = today.getMinutes();
              var second = today.getSeconds();

              today =
                mm +
                "_" +
                dd +
                "_" +
                yyyy +
                "_" +
                hour +
                "_" +
                minute +
                "_" +
                second;

              var blob = new Blob([response.data], {
                type: "application/pdf;charset=utf-8",
              });
              FileSaver.saveAs(blob, "Memorando_pagos_" + today);

              this.$toasted.show("El archivo fue exportado exitosamente", {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              });
            } catch (err) {
              this.$toasted.show(
                "Ocurrió un error al intentar exportar el archivo",
                {
                  theme: "toasted-primary",
                  position: "top-right",
                  duration: 10000,
                }
              );
            }
          } else {
            this.$toasted.show("No se encontraron datos para exportar.", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          }
          this.$store.commit("SET_LOADING", false);
          break;
      }
    },
    buscar(params) {
      this.fecha_inicio = params.fecha_inicio;
      this.fecha_fin = params.fecha_fin;
      this.convenio = params.convenio;
      this.index();
    },
    index(page = 1, paginar = 1) {
      this.$store.dispatch("pages/fetch", {
        endpoint: "portal/informes/memorando",
        params: {
          fecha_inicio: this.$moment(this.fecha_inicio).format("YYYY-MM-DD"),
          fecha_fin: this.$moment(this.fecha_fin).format("YYYY-MM-DD"),
          convenio: this.convenio,
          row: this.perPage,
          page: page,
          paginar: paginar,
        },
      });
    },
  },
  mounted() {
    this.index();
    if (this.$store.getters["pages/convenios"].length < 1) {
      this.$store.dispatch("pages/fetchConvenios", {
        endpoint: "portal/informes/convenio",
      });
    }
  },
};
</script>